module.exports = __webpack_public_path__ + "static/media/heading.d2931347.png";